import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  import useShopifyClient from '@/composables/useShopifyClient'
  import useIcons from '@/composables/useIcons'
  import useI18n from '@/composables/useI18n'
  import useCourse from '@/composables/useCourse'
  import useBreakpoint from '@/composables/useBreakpoint'

  import { UserModule } from '@/store/modules/user'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TrialStatusBanner',
  setup(__props) {

  const { course, trialTimeLeft, isTrialExpired } = useCourse()
  const { createShopifyCheckout } = useShopifyClient()
  const { arrowRightIndicator } = useIcons()
  const { translateString } = useI18n()
  const { isDesktopDevice } = useBreakpoint()

  const daysLeftText = computed(() => {
    const { days, hours } = trialTimeLeft.value(course.value)

    if (days <= 0 && hours <= 0) {
      return translateString('courses.courseTrials.testExpired')
    }

    if (days >= 1) {
      return translateString('courses.courseTrials.onlyXDaysLeft', { days })
    }

    return translateString('courses.courseTrials.onlyXHoursLeft', { hours })
  })

  const buyNow = () => {
    createShopifyCheckout(UserModule.email || undefined, course.value?.shopifyProductVariantId)
  }

  const extendTrial = () => {
    // TODO: Implement extend trial
  }

return { __sfc: true,course, trialTimeLeft, isTrialExpired, createShopifyCheckout, arrowRightIndicator, translateString, isDesktopDevice, daysLeftText, buyNow, extendTrial, computed, KetchUpButton, SVGRenderer, useShopifyClient, useIcons, useI18n, useCourse, useBreakpoint, UserModule }
}

})